import {
	createImageUrlBuilder,
	type SanityImageSource,
} from '@sanity/image-url'
import { config } from '#app/utils/sanity.config.ts'

const builder = createImageUrlBuilder(config)

interface SanityImageWithMetadata {
	asset: {
		_id: string
		metadata?: {
			dimensions: {
				width: number
				height: number
				aspectRatio: number
			}
		}
	}
	hotspot?: any
	crop?: any
	alt?: string
}

interface Props {
	source: SanityImageWithMetadata
	alt: string
	width?: number
	className?: string
}

export function SanityImage({ source, alt, width = 800, className }: Props) {
	const urlFor = (source: SanityImageSource) => builder.image(source)
	const srcSet = [320, 640, 1020, 1200]
		.map((w) => `${urlFor(source).width(w).auto('format').url()} ${w}w`)
		.join(', ')

	// Emit intrinsic width/height so the browser reserves aspect-ratio space
	// before load. Without this, lazy images inside auto-height containers
	// collapse to 0px in Firefox and never enter the viewport to load.
	const dimensions = source.asset?.metadata?.dimensions

	return (
		<img
			src={urlFor(source).width(width).url()}
			srcSet={srcSet}
			sizes="(max-width: 800px) 100vw, 800px"
			width={dimensions?.width}
			height={dimensions?.height}
			alt={alt}
			loading="lazy"
			className={`object-cover ${className}`}
		/>
	)
}
